// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3fuTq","tab":"styles__tab___2l57d","tabActive":"styles__tabActive___3noTa styles__tab___2l57d"};